import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=5c5194fa"
import script from "./PaymentSettings.vue?vue&type=script&lang=js"
export * from "./PaymentSettings.vue?vue&type=script&lang=js"
import style0 from "./PaymentSettings.vue?vue&type=style&index=0&id=5c5194fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports